import { QNotifyCreateOptions } from "quasar";

function showErrorNotification(message?: string): QNotifyCreateOptions {
  return {
    type: "negative",
    message: message || "An error occurred",
    position: "top",
    timeout: 10000,
    actions: [
      {
        icon: "close",
        round: true,
        color: "white",
        outline: true,
        flat: false,
        handler: () => {},
      },
    ],
  };
}

function showPositiveNotification(message: string): QNotifyCreateOptions {
  return {
    color: "positive",

    message: message,
    position: "top",
    progress: true,
    timeout: 5000,
    actions: [
      {
        icon: "close",
        round: true,
        color: "white",
        outline: true,
        flat: false,
        handler: () => {},
      },
    ],
  };
}

export { showErrorNotification, showPositiveNotification };
